import axios from 'axios'
const proxyConfig = require('../config/config');
const querystring = require('querystring');

const API_CLIENT = axios.create({
    baseURL: `${proxyConfig.ip_proxy + ':' + proxyConfig.port_proxy + '/' + proxyConfig.subPath }`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    timeout: proxyConfig.requestTimeout
});

const API3_CLIENT_JSON = axios.create({
    baseURL: `https://${window.location.host}/api3`,
    headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json'
    },
    timeout: proxyConfig.requestTimeout
});

export default {
    async refreshToken({locale, refreshToken}) {
        try {
            API_CLIENT.defaults.headers["Locale"] = locale;
            const GET_REFRESH_TOKEN = API_CLIENT.post(`/${proxyConfig.refresh_token}`,querystring.stringify({
                'grant_type': 'refresh_token',
                'client_id': proxyConfig.client_id,
                'client_secret': proxyConfig.client_secret,
                'refresh_token': refreshToken
            }));
            return await GET_REFRESH_TOKEN;
        } catch (e) {
            throw "500";
        }
    },

    async refreshTokenApi3({refreshTokenApi3}) {
        try {
            let refreshString = '{"token": "'+ refreshTokenApi3 +'"}';
            const GET_REFRESH_TOKEN = API3_CLIENT_JSON.post(`/auth/refresh-token`, refreshString);
            return await GET_REFRESH_TOKEN;
        } catch (e) {
            throw "500";
        }
    },
    async loginProxy({locale}, {m, p}) {
        try {
            API_CLIENT.defaults.headers["Locale"] = locale;
            const LOGIN_TO_PROXY = API_CLIENT.post(`/${proxyConfig.auth}`,querystring.stringify({
                'grant_type': 'password',
                'client_id': proxyConfig.client_id,
                'client_secret': proxyConfig.client_secret,
                'password': p,
                'username': m
            }));
            let sended = '{"password": "'+ p +'", "login": "'+ m +'", "networkAccount": true }';
            let error  = '';

            await fetch(`https://${window.location.host}/api3/auth/login`, {
                method: 'post',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: sended,
            }).then((response) => response.json())
                .then((data) => {

                    console.log('data?', JSON.stringify(data.payload));
                    console.log('datdata?.payload?.remoteAuthKeya', data?.payload?.remoteAuthKey);

                    window.localStorage.setItem('tetstststst', JSON.stringify(data.payload));

                    if (data?.payload?.remoteAuthKey) {
                        window.localStorage.setItem('myAESPass', data.payload.remoteAuthKey);
                    }

                    window.localStorage.setItem(
                        'accessTokenApi3',
                        data.payload.accessToken
                    );
                    window.localStorage.setItem(
                        'refreshTokenApi3',
                        data.payload.refreshToken
                    );
            }).catch(e => { 

                if (e?.toString().indexOf('TypeError') != -1 || e?.toString().indexOf('SyntaxError') != -1) {
                    console.log('90909090909e?.toString()', e?.toString())
                }
                
                if (e?.toString() == 'TypeError: Failed to fetch' || e?.toString().indexOf('SyntaxError') != -1) {
                    error = 'Server is not available'
                }        
            })

            return await LOGIN_TO_PROXY.then((response) => {
                return error || response
            })
        } catch (e) {
            let msg;
            if (e && e.response && e.response.data && e.response.data.oauth2 && e.response.data.oauth2.message)
                msg = e.response.data.oauth2.message;
            else
                msg = "Registration code is wrong";
            throw msg;
        }

    },
    async loginProxyAfter({locale}, {m, p, t}) {
        try {
            API_CLIENT.defaults.headers["Locale"] = locale;
            const LOGIN_TO_PROXY = API_CLIENT.post(`/${proxyConfig.auth}`,querystring.stringify({
                'grant_type': 'password',
                'client_id': proxyConfig.client_id,
                'client_secret': proxyConfig.client_secret,
                'password': p,
                'username': m,
                'proxyAuthToken': t
            }));
            let sended = '{"password": "'+ p +'", "login": "'+ m +'", "networkAccount": true }';
            await fetch(`https://${window.location.host}/api3/auth/login`, {
                method: 'post',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: sended,
            }).then((response) => response.json())
                .then((data) => {
                    window.localStorage.setItem(
                        'accessTokenApi3',
                        data.payload.accessToken
                    );
                    window.localStorage.setItem(
                        'refreshTokenApi3',
                        data.payload.refreshToken
                    );
                }).catch(e => { console.log(e) })

            return await LOGIN_TO_PROXY;
        } catch (e) {
            let msg;
            if (e && e.response && e.response.data && e.response.data.oauth2 && e.response.data.oauth2.message)
                msg = e.response.data.oauth2.message;
            else
                msg = "Registration code is wrong";
            throw msg;
        }

    },
    async loginProxyFromMail({locale}, {c}) {
        try {
            API_CLIENT.defaults.headers["Locale"] = locale;
            const LOGIN_TO_PROXY_WITH_CODE = API_CLIENT.post(`/${proxyConfig.auth_mail_code}`,querystring.stringify({
                'grant_type': 'mail:confirm',
                'client_id': proxyConfig.client_id,
                'client_secret': proxyConfig.client_secret,
                'mail_code': c
            }));
            return await LOGIN_TO_PROXY_WITH_CODE;
        } catch (e) {
            let msg;
            if (e && e.response && e.response.data && e.response.data.oauth2 && e.response.data.oauth2.message)
                msg = e.response.data.oauth2.message;
            else
                msg = "Registration code is wrong";
            throw msg;
        }

    }
}
